import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetTrendingsResponse } from './types';

export const getTrendings = async (): Promise<GetTrendingsResponse> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/tranding`;

	const response: GetTrendingsResponse = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching trendings:', error);
			return { trandings: [] };
		});

	return response;
};
